import React from 'react';

import { useLocalization } from '../../providers/LocaleProvider';
import { Flex } from '../Flex';
import { HighlightLabel } from '../HighlightLabel';
import { HeadlineH9, SubtitleST4 } from '../Typography';

interface MembershipDiscountHighlightProps {
  amount: number;
}

export const MembershipDiscountHighlight = ({ amount }: MembershipDiscountHighlightProps) => {
  const { t, fc } = useLocalization();

  return (
    <HighlightLabel
      as={Flex}
      ml="sp_0"
      mt="sp_12"
      p="sp_12"
      color="sys.success.text.strong"
      backgroundColor="sys.success.background.weak"
      whiteSpace="normal"
      width={1}
      boxSizing="border-box"
    >
      <Flex justifyContent="space-between" alignItems="center" width={1}>
        <SubtitleST4>{t('h24_save_as_a_member')}</SubtitleST4>
        <HeadlineH9 whiteSpace="nowrap" ml="sp_8">
          {fc(amount)}
        </HeadlineH9>
      </Flex>
    </HighlightLabel>
  );
};

export default MembershipDiscountHighlight;
